import { User } from "oidc-client-ts";

import { env } from "src/env";

// A static wrapper around oidc-client-ts User
export class AppUser {
  private static user: User | null;

  // Updates the user based on the new oidc user
  static setUser(user: User | null) {
    this.user = user;
  }

  static async getAuthorizationHeader() {
    return { authorization: `Bearer ${this.user?.access_token ?? ""}` };
  }

  static get isAuthenticationEnabled() {
    return !env.isAuthDisabled;
  }
  static getAccessToken() {
    return this.user?.access_token;
  }
}
